module.exports = __webpack_public_path__ + "media/assets/LanguagePicker-579be83b31f23fbee78dc4cbb793279c.svg";